module.exports = __webpack_public_path__ + "static/media/3_talking.068d1ead.jpg";